module.exports = __webpack_public_path__ + "basic2.png?587c96339033c70430ed2a25f026ea29";